import "%vendor%/libs/modernizr-custom.js";